import React from 'react';
import { RESIGN_DIALOG_BACKGROUND_PATH } from '../../config/welcomeAssets';
import { resolvePublicAssetBackgroundUrl } from '../../utils/resolvePublicAssetUrl';
import {
  shouldMirrorOpponentAvatar,
  shouldMirrorPlayerAvatar,
} from '../../avatars';
import {
  formatEmoteBubbleTwoWords,
  resolveBattleEmoteBubbleDisplay,
} from '../../utils/emoteSpeechI18n';
import './BattleCenterEmoteDisplay.css';

function resolveBubbleText(bubble, t) {
  if (!bubble) {
    return '';
  }
  return formatEmoteBubbleTwoWords(resolveBattleEmoteBubbleDisplay(bubble, t));
}

function CenterEmoteDialog({ text, portraitSrc, mirrorPortrait = false, portraitOnRight = false }) {
  if (!text) {
    return null;
  }
  if (typeof portraitSrc !== 'string' || !portraitSrc.trim()) {
    throw new Error('CenterEmoteDialog: portraitSrc is required');
  }

  return (
    <div
      className={[
        'battle-center-emote-dialog',
        portraitOnRight ? 'battle-center-emote-dialog--portrait-right' : '',
      ].filter(Boolean).join(' ')}
      style={{ '--battle-center-emote-dialog-bg': resolvePublicAssetBackgroundUrl(RESIGN_DIALOG_BACKGROUND_PATH) }}
    >
      <div className="battle-center-emote-dialog__inner">
        <img
          className="battle-center-emote-dialog__portrait"
          src={portraitSrc}
          alt=""
          aria-hidden
          draggable={false}
          style={{
            transform: mirrorPortrait ? 'scaleX(-1)' : 'none',
          }}
        />
        <p className="battle-center-emote-dialog__text">{text}</p>
      </div>
    </div>
  );
}

/**
 * Battlefield-center emote display at the four-zone cross intersection.
 * Opponent emote stacks above the local player emote when both are active.
 */
export default function BattleCenterEmoteDisplay({
  opponentBubble = null,
  playerBubble = null,
  opponentPortraitSrc = '',
  playerPortraitSrc = '',
  isMobile = false,
  t,
}) {
  const opponentText = resolveBubbleText(opponentBubble, t);
  const playerText = resolveBubbleText(playerBubble, t);

  if (!opponentText && !playerText) {
    return null;
  }

  return (
    <div
      className={[
        'battle-center-emote-stack',
        isMobile ? 'battle-center-emote-stack--mobile' : '',
      ].filter(Boolean).join(' ')}
      data-no-battle-flashlight="true"
      aria-live="polite"
    >
      {opponentText ? (
        <CenterEmoteDialog
          text={opponentText}
          portraitSrc={opponentPortraitSrc}
          mirrorPortrait={shouldMirrorOpponentAvatar()}
          portraitOnRight
        />
      ) : null}
      {playerText ? (
        <CenterEmoteDialog
          text={playerText}
          portraitSrc={playerPortraitSrc}
          mirrorPortrait={shouldMirrorPlayerAvatar()}
        />
      ) : null}
    </div>
  );
}
